import { createContext, useContext } from "react";

export const UsageContext = createContext(null);
const noop = () => {};

export function useUsagePlayback() {
  return useContext(UsageContext)?.runtime?.playback || noop;
}
